/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Voice_Agents_Outbound_Desc8Inputs */

const en_svc_ai_voice_agents_outbound_desc8 = /** @type {(inputs: Svc_Ai_Voice_Agents_Outbound_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow-ups, reminders, reactivations and review requests, dialed automatically within compliance limits.`)
};

const ar_svc_ai_voice_agents_outbound_desc8 = /** @type {(inputs: Svc_Ai_Voice_Agents_Outbound_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متابعات وتذكيرات وإعادة تنشيط وطلبات تقييم، يتم الاتصال بها تلقائيا ضمن الحدود النظامية.`)
};

const bn_svc_ai_voice_agents_outbound_desc8 = /** @type {(inputs: Svc_Ai_Voice_Agents_Outbound_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফলো-আপ, রিমাইন্ডার, পুনরায় সক্রিয়করণ আর রিভিউ অনুরোধ, নিয়মের মধ্যে থেকে স্বয়ংক্রিয়ভাবে ডায়াল করা।`)
};

const de_svc_ai_voice_agents_outbound_desc8 = /** @type {(inputs: Svc_Ai_Voice_Agents_Outbound_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow-ups, Erinnerungen, Reaktivierungen und Bewertungsanfragen, automatisch gewählt im Rahmen der Vorschriften.`)
};

const es_svc_ai_voice_agents_outbound_desc8 = /** @type {(inputs: Svc_Ai_Voice_Agents_Outbound_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguimientos, recordatorios, reactivaciones y solicitudes de reseñas, marcados automáticamente dentro de los límites normativos.`)
};

const fr_svc_ai_voice_agents_outbound_desc8 = /** @type {(inputs: Svc_Ai_Voice_Agents_Outbound_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relances, rappels, réactivations et demandes d'avis, appelés automatiquement dans le respect de la réglementation.`)
};

const pt_svc_ai_voice_agents_outbound_desc8 = /** @type {(inputs: Svc_Ai_Voice_Agents_Outbound_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow-ups, lembretes, reativações e pedidos de avaliação, discados automaticamente dentro dos limites legais.`)
};

const zh_svc_ai_voice_agents_outbound_desc8 = /** @type {(inputs: Svc_Ai_Voice_Agents_Outbound_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跟进、提醒、唤醒和邀评电话，在合规范围内自动拨打。`)
};

const tr_svc_ai_voice_agents_outbound_desc8 = /** @type {(inputs: Svc_Ai_Voice_Agents_Outbound_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takip, hatırlatma, yeniden kazanma ve yorum istekleri, mevzuat sınırları içinde otomatik aranır.`)
};

const ru_svc_ai_voice_agents_outbound_desc8 = /** @type {(inputs: Svc_Ai_Voice_Agents_Outbound_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дозвоны, напоминания, реактивации и запросы отзывов автоматически обзваниваются в рамках закона.`)
};

const pl_svc_ai_voice_agents_outbound_desc8 = /** @type {(inputs: Svc_Ai_Voice_Agents_Outbound_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow-upy, przypomnienia, reaktywacje i prośby o opinie, wybierane automatycznie w granicach przepisów.`)
};

/**
* | output |
* | --- |
* | "Follow-ups, reminders, reactivations and review requests, dialed automatically within compliance limits." |
*
* @param {Svc_Ai_Voice_Agents_Outbound_Desc8Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_voice_agents_outbound_desc8 = /** @type {((inputs?: Svc_Ai_Voice_Agents_Outbound_Desc8Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Voice_Agents_Outbound_Desc8Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_voice_agents_outbound_desc8(inputs)
	if (locale === "bn") return bn_svc_ai_voice_agents_outbound_desc8(inputs)
	if (locale === "de") return de_svc_ai_voice_agents_outbound_desc8(inputs)
	if (locale === "es") return es_svc_ai_voice_agents_outbound_desc8(inputs)
	if (locale === "fr") return fr_svc_ai_voice_agents_outbound_desc8(inputs)
	if (locale === "pt") return pt_svc_ai_voice_agents_outbound_desc8(inputs)
	if (locale === "zh") return zh_svc_ai_voice_agents_outbound_desc8(inputs)
	if (locale === "tr") return tr_svc_ai_voice_agents_outbound_desc8(inputs)
	if (locale === "ru") return ru_svc_ai_voice_agents_outbound_desc8(inputs)
	if (locale === "pl") return pl_svc_ai_voice_agents_outbound_desc8(inputs)
	return en_svc_ai_voice_agents_outbound_desc8(inputs)
});
export { svc_ai_voice_agents_outbound_desc8 as "svc_ai-voice-agents_OUTBOUND_desc" }